import { ApiError } from './client'

// Presentation only. Authentication, missing resources, conflicts and invalid
// response contracts never become stale-but-usable data.
export function canRetainReadData(error: unknown): boolean {
  return (
    error instanceof ApiError &&
    (error.code === 'transport' ||
      (error.code === 'server' && error.status !== null && error.status >= 500))
  )
}
